@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.add-to-batch-wrapper {
  display: inline-flex;
}

.dropdown-section-header {
  background-color: @add-to-batch--dropdown--background-color;
  font-size: 14px;
  padding: 10px 5px;
  border-bottom: 1px solid @add-to-batch--dropdown--border-color;
}

.batch-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shipment-count {
  background-color: @add-to-batch--dropdown--background-color;
  border-radius: 4px;
  padding: 3px;
  margin-left: 5px;
}

.load-more-button {
  padding: 10px;
  border-top: 1px solid @add-to-batch--dropdown--border-color;
  background-color: @dropdown-menu-item--background-color;
}

.version2 {
  max-width: 224px;
  max-height: 240px;
  background: var(--default--background-color-19);
  box-shadow: 0 8px 4px -4px var(--default--box-shadow-color--8);
  border-radius: 4px;
  .order-details-add-to-batch-dropdown-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: @space-8 @space-16;
    line-height: 24px;
    height: 35px;
    .batch-row {
      gap: @space-8;
    }
    .batch-row > .batch-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 151px;
    }
    .batch-row > .shipment-count {
      background: var(--default--background-color-20);
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding: @space-4 @space-8;
      height: 24px;
    }
    &:disabled {
      background: var(--primary--selected--background-color--1);
      &:hover {
        background: var(--primary--selected--background-color--1);
      }
    }
  }
  .dropdown-section-header {
    background: var(--default--background-color--14);
    border-bottom: 1px solid var(--default--border-color--12);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: @space-8 @space-16;
    gap: @space-8;
    height: 35px;
  }
  .load-more-button {
    padding: @space-0;
  }
  .dropdown-menu-item {
    color: var(--default--text-color--18);
  }
}
